export default __webpack_public_path__ + "static/Anita Roberts-ff966ae881a6daa2b3ad394d0c3081eb.jpg";